var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * BeoDataTable is custom made DataTable component.
 *
 * @author rajeev.k
 * @description This component is an extension of PrimeReact DataTable tag (<DataTable/>).
 * All properties of PrimeReact DataTable can be used by this BeoDataTable component.
 */
import { DataTable } from "primereact/datatable";
import { useTranslation } from "react-i18next";
var BeoDataTable = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var id = _a.id, ref = _a.ref, props = __rest(_a, ["id", "ref"]);
    var t = useTranslation().t;
    return (_jsx(DataTable, __assign({ ref: ref, id: id, editMode: (_b = props === null || props === void 0 ? void 0 : props.editMode) !== null && _b !== void 0 ? _b : "row", className: (_c = props === null || props === void 0 ? void 0 : props.className) !== null && _c !== void 0 ? _c : "w-full", paginator: (_d = props === null || props === void 0 ? void 0 : props.paginator) !== null && _d !== void 0 ? _d : false, rows: (_e = props === null || props === void 0 ? void 0 : props.rows) !== null && _e !== void 0 ? _e : 3, rowsPerPageOptions: (_f = props === null || props === void 0 ? void 0 : props.rowsPerPageOptions) !== null && _f !== void 0 ? _f : [3, 5, 10, 15], paginatorTemplate: (_g = props === null || props === void 0 ? void 0 : props.paginatorTemplate) !== null && _g !== void 0 ? _g : "RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink", alwaysShowPaginator: (_h = props === null || props === void 0 ? void 0 : props.alwaysShowPaginator) !== null && _h !== void 0 ? _h : true, emptyMessage: t("com.beo.dakz.datatable.emptymessage") }, props)));
};
export default BeoDataTable;
